// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1fu41","calendarButtons":"ClockData_calendarButtons__hhfOF"};